var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tabs),function(tab,i){return _c('span',{key:i,staticClass:"text-base text-darkPurple font-semibold block py-2 cursor-pointer",class:[
      _vm.currentTab === _vm.tabs[i] ? 'activeTab tw-text-primary' : 'inactiveTab',
    ]},[_vm._v(" "+_vm._s(tab)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }